import React, { Component } from 'react'
import { Row, Popover, Tooltip, Button, BackTop, Badge } from 'antd';
import { Route, Link, withRouter, Switch, Redirect } from "react-router-dom";
import DashboardPage from './dashboard';
import AllDataPage from './recon';
import ReportsPage from './reports';
import SettingPage from './settings';
import ProfilePage from '../components/profile_page';
import TestPage from '../test';
import ChangePasswordView from './auth/change_password';
import ActivityPage from './activity/index';
import { AvTimerOutlined, HorizontalSplitOutlined, OfflineBoltOutlined, AssessmentOutlined, SubjectOutlined, SettingsOutlined, NotificationsNone } from '@material-ui/icons';
import NotificationPage from './notification/index';
import { COLORS } from './theme';
import { PollingServices } from '../lib/poller';
import { RESTExecutor, withDomains } from '../lib/domain';
import AnimatedSearchInput from '../components/animated_search_input';
import KeyboardShortcutWrapper from '../util/keyshortcuts/index';
import { MainListener } from '../util/keyshortcuts/listener';
import { withWhiteLabelContext } from 'react-whitelabel';


const NAV_BAR_1_HEIGHT = 64;
const NAV_BAR_2_HEIGHT = 54;
const ACTION_BAR_3_HEIGHT = 100;
var didScroll;
var lastScrollTop = 0;
var delta = 10;

new MainListener().initialize()





export const main_menu_list = {
    "dashboard": {
        title: "Dashboard",
        url: "/dashboard",
        key: 'dashboard',
        icon: <AvTimerOutlined />,
        shortcut_label: "1"
    },
    "recon": {
        title: "Recon",
        url: "/recon",
        key: 'recon',
        icon: <HorizontalSplitOutlined />,
        shortcut_label: "2"
    },
    "activity": {
        title: "Activity",
        url: "/activity",
        key: 'activity',
        icon: <OfflineBoltOutlined />,
        shortcut_label: "3"
    },
    "reports": {
        title: "Reports",
        url: "/reports",
        key: 'reports',
        icon: <AssessmentOutlined />,
        shortcut_label: "4"
    }
}
class MainPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            slider_hidden: false,
            header_hidden: false,
            notification_count: 0,
            nav_prefixed: false
        }

        this.lastScrollPosition = 0;
        window.header = this;

        this.poller = new PollingServices(this, null, (data, key) => {
            console.log("object received", data, key);
            this.setState({ notification_count: data.count });
            return false
        }, '/my-notifications-count');

        this.count_notification = RESTExecutor.list().config({
            label: 'count'
        }).callbacks((success) => {
            this.setState({
                notification_count: success.result.count
            })
        }).connect(props.domains.notification);

    }

    assignSliderState = (val) => {
        this.setState({
            slider_hidden: val
        })
    }

    refreshNotifiicationCount = (delay = 5000) => {
        console.log("refresh called")
        setTimeout(() => {
            this.count_notification.execute()
        }, delay);
    }

    render() {

        let permissions = this.props.permissions || [];
        let pathname = this.props.location.pathname || "";
        let mainMenuSelected = pathname.split("/")[1];
        const { header_hidden, notification_count } = this.state;


        let providedLabel=this.props.label||{};


        return (
            <div style={{
                // overflowY:'scroll',
            }}>
                <div style={{
                    padding: '0px 24px 0px 0px',
                    backgroundColor: 'white',
                    boxShadow: '0 0 10px 0 rgba(152,103,172,0.25)',
                    // position: 'fixed',
                    // top:header_hidden?-64:0,
                    height: 56,//header_hidden?0:64,
                    width: '100%',
                    // top:0,
                    // zIndex: 2,
                    overflow: 'hidden',
                    transition: 'height 300ms , top 300ms',
                }} className='sticky-content'>

                    <Row type='flex' style={{
                        flexWrap: 'nowrap',
                        // overflowX: 'clip',
                        height: '100%',
                        alignItems: 'center',
                        width: '100%'
                    }}>
                        <div
                            title="Toggle Fullscreen"
                            className='hand-cursor'
                            onClick={() => {
                                try {
                                    if (document.fullscreen) {
                                        document.exitFullscreen();
                                    } else {

                                        document.documentElement.requestFullscreen();
                                    }
                                } catch (e) {

                                }
                            }}
                            style={{
                                width: 250,
                                minWidth: 250,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                transition: 'all 0.2s',
                                overflow: 'hidden'
                                // backgroundColor:'red'
                            }}>
                            <img alt={providedLabel.p_name} style={{
                                height: 28, marginLeft: 12
                            }} src={require('../logo_alt.png')} />

                        </div>
                        <div style={{
                            width: 60,
                            minWidth: 60,
                            // backgroundColor:'green',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%'
                        }}>

                            <SubjectOutlined
                                titleAccess={this.state.slider_hidden ? "Show Sidebar" : "Hide Sidebar"}
                                className='hand-cursor'
                                onClick={() => {
                                    try {
                                        window.slider_main.toggleSlider(
                                            (new_val) => {
                                                this.setState({
                                                    slider_hidden: new_val
                                                })
                                            }
                                        );

                                    } catch (e) { }
                                }}
                                style={{
                                    fontSize: 24
                                }} />
                        </div>
                        <Row type='flex' justify='space-between' style={{
                            flexWrap: 'nowrap',
                            // overflowX: 'clip',
                            height: '100%',
                            alignItems: 'center',
                            // backgroundColor:'blue',
                            flex: 1
                        }}>
                            <Row type='flex' style={{
                                flexWrap: 'nowrap',
                                overflowX: 'hidden',
                                height: '100%',
                                alignItems: 'center',
                                // width: '100%'
                            }}>
                                {
                                    Object.keys(main_menu_list).map((key, index) => {
                                        let item = main_menu_list[key];
                                        let indicatorProps = {};
                                        if (item.key === mainMenuSelected) {
                                            indicatorProps = {
                                                height: 3
                                            }
                                        }

                                        return <KeyboardShortcutWrapper
                                        key={index}
                                            trigger={`Alt+${item.shortcut_label}`}
                                            label={item.shortcut_label}
                                            onDown={() => {
                                                this.props.history.push(item.url)
                                            }}
                                        ><Link tabIndex={0} to={item.url}
                                            key={index}
                                            className={'header-menu-item'}
                                            style={{
                                                height: '100%'
                                            }} >

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    height: '100%'
                                                }}>
                                                    <div style={{
                                                        height: 3,
                                                        width: '100%',
                                                        // backgroundColor:'red'
                                                    }}></div>
                                                    <Tooltip title={item.title} mouseEnterDelay={1}>
                                                        <div key={index}
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'center',
                                                                height: '100%',
                                                                marginRight: 15,
                                                                marginLeft: 15,
                                                                cursor: 'pointer',
                                                                padding: 4,
                                                                paddingRight: 10,
                                                                paddingLeft: 10,
                                                                borderRadius: 20,
                                                                // ...selectedProps
                                                            }}
                                                            className='header-menu-item-child'
                                                        >
                                                            <div style={{
                                                                position: 'relative',
                                                            }}>
                                                                <div style={{
                                                                    height: 30,
                                                                    width: 30,
                                                                    // borderRadius: 20,
                                                                    // opacity: 0.6
                                                                }}>

                                                                </div>
                                                                {/* {item.icon} */}
                                                                {React.cloneElement(item.icon, {
                                                                    className: item.key === mainMenuSelected ? '' : "header-menu-item-icon",
                                                                    style: {
                                                                        fontSize: 24,
                                                                        color: item.key === mainMenuSelected ? '#3851A3' : '#878F9D',
                                                                        position: 'absolute',
                                                                        left: '50%',
                                                                        top: '50%',
                                                                        transform: 'translate(-50%, -50%)'
                                                                    }
                                                                })}
                                                            </div>
                                                            <h1
                                                                className={item.key === mainMenuSelected ? '' : "header-menu-item-title"}
                                                                style={{
                                                                    margin: 0,
                                                                    marginLeft: 16,
                                                                    color: item.key === mainMenuSelected ? '#3851A3' : '#878F9D',
                                                                    fontSize: 16,
                                                                    fontWeight: 'bold',
                                                                    textTransform: 'uppercase',
                                                                }}>
                                                                {item.title}
                                                            </h1>
                                                        </div>
                                                    </Tooltip>
                                                    <div style={{
                                                        height: 5,
                                                        width: '100%',
                                                        // backgroundColor:'red'
                                                    }}>
                                                        <div className={item.key === mainMenuSelected ? '' : 'header-menu-item-indicator'} style={{
                                                            ...indicatorProps,
                                                            backgroundColor: item.key === mainMenuSelected ? '#3851A3' : 'transparent',
                                                            "--indicatorHeight": item.key === mainMenuSelected ? 5 : 0,
                                                            "--indicatorColor": item.key === mainMenuSelected ? '#3851A3' : 'transparent'
                                                        }}>

                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </KeyboardShortcutWrapper>
                                    })
                                }

                            </Row>
                            <Row type='flex' className='mobile-hide' style={{
                                alignItems: 'center', color: 'black', flexWrap: 'nowrap',
                                overflowX: 'clip'
                            }} >
                                <AnimatedSearchInput />
                                <KeyboardShortcutWrapper
                                    trigger={`Alt+N,Alt+n`}
                                    label={"N"}
                                    wrapperStyle={{
                                        display:'flex'
                                    }}
                                    onDown={() => {
                                        this.props.history.push('/notifications')
                                    }}
                                >
                                    <Badge count={notification_count} >
                                        <NotificationsNone
                                            className='hand-cursor'
                                            onClick={() => {
                                                this.props.history.push('/notifications')
                                            }} titleAccess='Notifications' style={{ fontSize: 24, marginLeft: 20, color: 'notifications' === mainMenuSelected ? COLORS.primary : COLORS.secondary }}

                                        /></Badge>
                                </KeyboardShortcutWrapper>
                                {/* <NotificationPage /> */}
                                {permissions.includes("SuperAdmin") &&
                                    // <Link to={'/settings'}>
                                    <SettingsOutlined
                                        className='hand-cursor'
                                        onClick={() => {
                                            this.props.history.push('/settings')
                                        }} titleAccess='Setting' style={{ fontSize: 24, marginLeft: 20, color: 'settings' === mainMenuSelected ? COLORS.primary : COLORS.secondary }} />
                                    // </Link>
                                }
                                <ProfilePage />
                            </Row>
                            {/* <Row type='flex' className='mobile-show' style={{
                            alignItems: 'center', color: 'black', flexWrap: 'nowrap',
                        }} >
                            <Popover placement='bottomRight' content={<div>
                                <NotificationPage />
                                {permissions.includes("SuperAdmin") &&
                                    <Link to={'/settings'}>
                                        <SettingsOutlined type='setting' style={{ fontSize: 24, marginLeft: 20, color: 'settings' === mainMenuSelected ? '#3851A3':"#878F9D" }} />
                                    </Link>
                                }
                                <ProfilePage />
                            </div>} trigger='hover' >
                                <Icon type="more" style={{ fontSize: 30 }} />
                            </Popover>
                        </Row> */}
                        </Row>
                    </Row>
                </div>




                <div style={{
                }} >
                    <BackTop visibilityHeight={100} />
                    <Switch>
                        <Route path='/dashboard' component={DashboardPage} />
                        <Route path='/recon' component={AllDataPage} />
                        <Route path='/activity' component={ActivityPage} />
                        <Route path='/notifications' component={NotificationPage} />
                        <Route path='/reports' component={ReportsPage} />
                        {permissions.includes("SuperAdmin") && <Route path='/settings' component={SettingPage} />}
                        <Route path='/change-password' component={ChangePasswordView} />
                        {/* {process.env.NODE_ENV==='development' && */}
                        <Route path='/test' component={TestPage} />
                        {/* } */}
                        <Redirect from='*' to='/dashboard' />

                    </Switch>
                </div>
            </div>
        )
    }

    scrollHandler = () => {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // if(this.state.nav_prefixed)
        console.log("nav fixed ", this.state.nav_prefixed, scrollTop)
        if (this.state.nav_prefixed) {
            if (scrollTop < 20) {
                console.log("event triggerred")
                this.setState({ nav_prefixed: false })
            }
        } else {
            if (scrollTop > 21) {
                console.log("event triggerred")
                this.setState({ nav_prefixed: true })
            }
        }
        // if (scrollTop < 54 && this.state.nav_prefixed) {
        //     console.log("nav scrolled down")
        //     this.setState({ nav_prefixed: false })
        // } else if(this.state.nav_prefixed && scrollTop>54) {
        //     console.log("nav fixed")
        //     this.setState({ nav_prefixed: true })

        // }
        this.lastScrollPosition = scrollTop
    }

    hasScrolled = () => {
        var st = window.pageYOffset || document.documentElement.scrollTop;

        console.log("st is", st)
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > NAV_BAR_1_HEIGHT) {
            // Scroll Down
            console.log("scrolled down trigger")
            this.setState({ header_hidden: true })
            // $('header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            this.setState({ header_hidden: false })
            console.log("scrolled up trigger")

        }

        lastScrollTop = st;
    }


    componentDidMount() {
        window.header = this;

        this.refreshNotifiicationCount(0)

        // this.poller.startPolling('notification-count','key',5000,100*5000);
        //    var ctx=this;

        //     setInterval(function() {
        //         if (didScroll) {
        //             ctx.hasScrolled()
        //             didScroll = false;
        //         }
        //     }, 250);

        // window.addEventListener('scroll', this.scrollHandler)
    }
    componentWillUnmount() {
        window.header = null;
        try {
            // this.poller.pauseEvent('notification-count')
        } catch (e) {

        }
        // window.removeEventListener('scroll', this.scrollHandler)

    }
}

export default withRouter(withWhiteLabelContext(withDomains(MainPage, "notification")))
